import React from "react";
//import PropTypes from 'prop-types';

import { useFormField } from "state/hooks";
import TextField from "components/fields/text/TextField";
import IconButton from "components/IconButton";
import Select from "components/fields/select/ControlledSelect";
import Button from "components/Button";
import roomsReducer from "./reducer";
import { useSelector } from "react-redux";
import { selectFieldValue } from "state/selectors/data";

function RoomTypeSelect(props) {
    const { onChange, value } = props;
    const options = useSelector((store) => {
        const optionsList =
            selectFieldValue(
                store,
                "schema.data",
                "data.room-type",
                "values"
            ) || [];
        return optionsList.map((value) => {
            const option = store?.data?.["schema.data.value"]?.[value];
            return { id: option.value, label: option.label };
        });
    });
    const visibleValue = options.find((opt) => opt.id === value);
    return (
        <Select
            onChange={onChange}
            value={visibleValue?.label || value}
            options={options}
            variant={"dense"}
        />
    );
}

export function FlatRooms({ id }) {
    const { value, onChange } = useFormField(id);
    const dispatch = (...args) => onChange(roomsReducer(value, ...args));
    const addLevel = () => dispatch({ type: "ADD_LEVEL" });
    const removeLevel = (id) => dispatch({ type: "REMOVE_LEVEL", id });
    const changeRoom = (level, id, data) => {
        dispatch({ type: "CHANGE_ROOM", level, id, data });
    };
    const addRoom = (level) => {
        dispatch({ type: "ADD_ROOM", level });
    };
    const removeRoom = (id) => {
        dispatch({ type: "REMOVE_ROOM", id });
    };
    if (!value.length) {
        return <Button onClick={() => addRoom()}>Dodaj pomieszczenie</Button>;
    }
    return (
        <div>
            {value.map((level, levelNo) => (
                <div key={level.id}>
                    <div className={"cols cols-middle cols-spread gap-sm"}>
                        <div>Poziom {levelNo + 1}</div>
                        <div className={"cols"}>
                            <IconButton
                                icon={"mui-close"}
                                onClick={() => removeLevel(level.id)}
                            />
                            <IconButton
                                icon={"mui-add_circle"}
                                onClick={() => addRoom(level.id)}
                            />
                        </div>
                    </div>
                    {level.rooms?.map((room) => (
                        <div className="cols cols-middle gap-sm" key={room.id}>
                            <RoomTypeSelect
                                value={room.type}
                                onChange={(type) =>
                                    changeRoom(level.id, room.id, { type })
                                }
                                label={"Typ pomieszczenia"}
                            />
                            <TextField
                                onChange={(val) =>
                                    changeRoom(level.id, room.id, { area: val })
                                }
                                value={room.area}
                                variant={"dense"}
                                placeholder={"Powierzchnia"}
                            />
                            <IconButton
                                icon={"mui-close"}
                                onClick={() => removeRoom(room.id)}
                            />
                        </div>
                    ))}
                </div>
            ))}
            <div className={"cols cols-right"}>
                <Button variant={"text"} onClick={() => addLevel()}>
                    Dodaj poziom
                </Button>
            </div>
        </div>
    );
}

FlatRooms.propTypes = {};

FlatRooms.defaultProps = {
    value: [],
};

export default FlatRooms;
